import { signOut } from "firebase/auth";
import { auth } from "../firebase-config";

export const Private = () => {
  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        console.log("User signed out");
        window.location.href = "/";
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  return (
    <section>
      <h2>Private Page</h2>
      <p>This is a private page</p>
      <button onClick={handleSignOut}>Sign Out</button>
    </section>
  );
};
